import { type PlayerProfileResponse } from '@on3/api';
import clsx from 'clsx';
import { MockDataBar } from 'components/Mock/MockDataBar';

import styles from './StatsMock.module.scss';

interface StatsMockProps {
  player: PlayerProfileResponse;
  className?: string;
}
export const StatsMock = ({ player, className }: StatsMockProps) => {
  const classYear = player.classYear ?? new Date().getFullYear();
  const schoolName = player.highSchool?.knownAs ?? player.highSchoolName;
  const statsData = [
    { year: classYear, name: schoolName },
    { year: classYear - 1, name: schoolName },
    { year: classYear - 2, name: schoolName },
  ];

  return (
    <div className={clsx(styles.block, className)}>
      <table>
        <colgroup>
          <col style={{ width: 'min-content' }} />
          <col style={{ width: 'minmax(50px, 1fr)' }} />
          <col style={{ width: 'minmax(50px, 1fr)' }} />
          <col style={{ width: 'minmax(50px, 1fr)' }} />
          <col style={{ width: 'minmax(50px, 1fr)' }} />
          <col style={{ width: 'minmax(50px, 1fr)' }} />
        </colgroup>
        <thead>
          <tr>
            <th>Defensive</th>
            <th>TOT</th>
            <th>SOLO</th>
            <th>AST</th>
            <th>PD</th>
            <th>SACK</th>
            <th>FF</th>
          </tr>
        </thead>
        <tbody>
          {statsData.map(({ year, name }) => (
            <tr key={year}>
              <td>
                {year} <strong>{name}</strong>
              </td>
              {[...Array(6)].map((_, index) => (
                <td key={index}>
                  <MockDataBar />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
